/* Kraxelgaudi model-specific size guide. Existing variant controls remain authoritative. */
(function () {
  'use strict';
  if (window.__kgSizeGuideV1) return;
  window.__kgSizeGuideV1 = true;
  var instances = new Map();
  var queued = false;
  var opened = null;
  var serial = 0;
  var smartSelector = 'smart-widget .sw-offers[role="radiogroup"] .sw-slot-controls.sw-kit-controls select.sw-select';
  var sizeName = /^(größe|groesse|size)(?:$|[\s-])/i;
  var format = new Intl.NumberFormat('de-DE', {maximumFractionDigits: 1});

  function norm(value) {
    var s = String(value == null ? '' : value).trim().toUpperCase().replace(/\s+/g, '').replace(/[–-]/g, '/');
    if (s === '2XL') return 'XXL';
    if (s === '2XS') return 'XXS';
    return s;
  }
  function visible(element) { return !!element && !!element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden'; }
  function node(tag, className, text) {
    var result = document.createElement(tag);
    if (className) result.className = className;
    if (text != null) result.textContent = text;
    return result;
  }
  function sizeIndex(product) { return product.options.findIndex(function (name) { return sizeName.test(name); }); }
  function equalSize(row, value) { return [row.size].concat(row.aliases || []).some(function (s) { return norm(s) === norm(value); }); }
  function rowFor(chart, value) { return chart.rows.find(function (row) { return equalSize(row, value); }); }
  function id(value) { return String(value == null ? '' : value).split('/').pop(); }
  function validProduct(product) {
    return product && product.id && product.model && Array.isArray(product.options) && Array.isArray(product.variants) && sizeIndex(product) >= 0;
  }
  function variantById(product, value) { return product.variants.find(function (v) { return id(v.id) === id(value); }); }
  function configFor(mount) {
    try {
      var script = mount.querySelector('[data-kg-size-guide-config]');
      var cfg = script && JSON.parse(script.textContent);
      if (!cfg || !validProduct(cfg.product) || !cfg.charts || !cfg.charts[cfg.product.model]) return null;
      if (cfg.pageUrl) {
        cfg.charts[cfg.product.model].page = cfg.charts[cfg.product.model].page || {};
        cfg.charts[cfg.product.model].page.url = cfg.pageUrl;
      }
      return cfg;
    } catch (error) { console.warn('Kraxelgaudi: Größentabellen-Konfiguration ist ungültig.'); return null; }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }
  function owned(element) {
    return element && element.nodeType === 1 && (element.closest('[data-kg-size-guide-dialog], [data-kg-sg-owned]') || element.matches('[data-kg-size-guide-dialog], [data-kg-sg-owned]'));
  }
  function bootstrap(mount, cfg) {
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return null;
    var instance = {mount: mount, cfg: cfg, bindings: [], dialog: null, context: null, pending: '', opener: null, uid: 'kg-sg-' + (++serial)};
    instance.scope = mount.closest('product-info') || document.getElementById('MainProduct-' + cfg.sectionId) || document.getElementById('MainContent') || document;
    return instance;
  }
  function availableProducts(instance) {
    return [instance.cfg.product, instance.cfg.partner].filter(function (p) { return validProduct(p) && instance.cfg.charts[p.model]; });
  }
  function identifySmart(instance, select) {
    var products = availableProducts(instance);
    // Variant IDs are globally unique. Do not infer companion identity from DOM order or text.
    var candidates = products.filter(function (product) {
      return Array.from(select.options).some(function (option) { return !!variantById(product, option.value); });
    });
    return candidates.length === 1 ? candidates[0] : null;
  }
  function locateNative(instance) {
    var product = instance.cfg.product;
    var picker = instance.scope.querySelector('variant-selects[data-product-id="' + id(product.id) + '"]') || instance.scope.querySelector('variant-selects');
    if (!picker || !visible(picker)) return null;
    var inputs = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]')).filter(function (input) { return sizeName.test(input.dataset.optionName); });
    if (inputs.length) {
      var fieldset = inputs[0].closest('fieldset');
      return fieldset && visible(fieldset) ? {kind: 'native', element: fieldset, picker: picker, product: product} : null;
    }
    var select = Array.from(picker.querySelectorAll('select')).find(function (s) {
      var option = s.querySelector('option[data-option-name]');
      return (option && sizeName.test(option.dataset.optionName)) || /^options\[(größe|groesse|size)\]$/i.test(s.name);
    });
    return select && visible(select) ? {kind: 'native-select', element: select, picker: picker, product: product} : null;
  }
  function trigger(instance, context, parent, after) {
    var existing = instance.bindings.find(function (binding) { return binding.element === context.element && binding.button.isConnected; });
    if (existing) return existing;
    var wrap = node('div', 'kg-sg-trigger-wrap');
    wrap.dataset.kgSgOwned = instance.uid;
    var button = node('button', 'kg-sg-trigger');
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', instance.uid + '-dialog');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v4m4-4v3m4-3v4m4-4v3"/></svg>';
    button.appendChild(document.createTextNode(context.kind === 'smart' ? 'Größentabelle' : 'Größentabelle & richtig messen'));
    wrap.appendChild(button);
    if (after) after.insertAdjacentElement('afterend', wrap); else parent.appendChild(wrap);
    var binding = Object.assign(context, {wrap: wrap, button: button});
    instance.bindings.push(binding);
    button.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); show(instance, binding); });
    return binding;
  }
  function attach(instance) {
    instance.bindings = instance.bindings.filter(function (binding) {
      if (binding.element.isConnected && binding.button.isConnected) return true;
      binding.wrap.remove();
      return false;
    });
    var native = locateNative(instance);
    if (native) {
      trigger(instance, native, null, native.kind === 'native' ? native.element : native.element.closest('.product-form__input') || native.element);
    }
    instance.scope.querySelectorAll(smartSelector).forEach(function (select) {
      if (!visible(select)) return;
      var product = identifySmart(instance, select);
      if (!product) return;
      trigger(instance, {kind: 'smart', element: select, product: product}, select.closest('.sw-slot-controls'));
    });
    var hasLiveControls = instance.bindings.some(function (binding) { return binding.kind !== 'readonly' && visible(binding.element); });
    var readOnly = instance.bindings.find(function (binding) { return binding.kind === 'readonly'; });
    if (!hasLiveControls && !readOnly) {
      readOnly = trigger(instance, {kind: 'readonly', element: instance.mount, product: instance.cfg.product}, instance.mount);
    }
    if (readOnly) readOnly.wrap.hidden = hasLiveControls;
    var fallback = instance.mount.querySelector('[data-kg-size-guide-fallback]');
    if (fallback && !fallback.hidden) fallback.hidden = true;
    instance.scope.querySelectorAll('.kg2p-gt-link').forEach(function (legacy) { legacy.hidden = true; });
  }
  function currentContext(instance, context) {
    if (context.kind === 'readonly') return context;
    if (context.element.isConnected) return context;
    // Dawn or SMART may replace its controls while the dialog is open.
    attach(instance);
    return instance.bindings.find(function (binding) { return binding.kind === context.kind && id(binding.product.id) === id(context.product.id) && visible(binding.element); }) || null;
  }
  function nativeSelection(context) {
    var product = context.product;
    var selectedVariant = null;
    try { selectedVariant = JSON.parse((context.picker.querySelector('[data-selected-variant]') || {}).textContent || 'null'); } catch (error) {}
    return product.options.map(function (name, index) {
      var input = Array.from(context.picker.querySelectorAll('input[data-option-name]:checked')).find(function (control) { return control.dataset.optionName === name; });
      if (input) return input.value;
      var select = Array.from(context.picker.querySelectorAll('select')).find(function (control) { return control.name === 'options[' + name + ']'; });
      if (select) return select.value;
      // Preserve the shop's deliberate "choose a size" state; fallback only for other options.
      return index !== sizeIndex(product) && selectedVariant && selectedVariant.options ? selectedVariant.options[index] : null;
    });
  }
  function selection(context) {
    if (!context || context.kind === 'readonly') return [];
    if (context.kind === 'smart') {
      var variant = variantById(context.product, context.element.value);
      return variant ? variant.options : [];
    }
    return nativeSelection(context);
  }
  function targetFor(context, row) {
    if (!context || context.kind === 'readonly') return null;
    var product = context.product;
    var index = sizeIndex(product);
    var selected = selection(context);
    // Without a selected color/options, never silently choose another combination.
    if (product.options.some(function (_, i) { return i !== index && selected[i] == null; })) return null;
    var variant = product.variants.find(function (candidate) {
      return candidate.available === true && equalSize(row, candidate.options[index]) && candidate.options.every(function (value, i) { return i === index || value === selected[i]; });
    });
    if (!variant) return null;
    if (context.kind === 'smart') {
      var option = Array.from(context.element.options).find(function (o) { return id(o.value) === id(variant.id); });
      return !context.element.disabled && option && !option.disabled ? {variant: variant, control: context.element, value: option.value} : null;
    }
    if (context.kind === 'native-select') {
      var opt = Array.from(context.element.options).find(function (o) { return norm(o.value) === norm(variant.options[index]); });
      return !context.element.disabled && opt && !opt.disabled ? {variant: variant, control: context.element, value: opt.value} : null;
    }
    var radio = Array.from(context.element.querySelectorAll('input[type="radio"][data-option-name]')).find(function (r) { return norm(r.value) === norm(variant.options[index]); });
    return radio && !radio.disabled && !radio.classList.contains('disabled') && radio.getAttribute('aria-disabled') !== 'true' ? {variant: variant, control: radio, value: radio.value} : null;
  }
  function buildDialog(instance) {
    var dialog = node('dialog', 'kg-sg-dialog');
    dialog.id = instance.uid + '-dialog';
    dialog.dataset.kgSizeGuideDialog = instance.uid;
    dialog.setAttribute('aria-labelledby', instance.uid + '-title');
    dialog.setAttribute('aria-describedby', instance.uid + '-subtitle');
    dialog.innerHTML = '<div class="kg-sg-heading"><div><p class="kg-sg-eyebrow">KRAXELGAUDI · GRÖSSENTABELLE</p><h2 id="' + instance.uid + '-title">Damit’s richtig sitzt.</h2><p class="kg-sg-subtitle" id="' + instance.uid + '-subtitle"></p></div><button type="button" class="kg-sg-close" aria-label="Größentabelle schließen">×</button></div><div class="kg-sg-content"><div class="kg-sg-measure"><svg class="kg-sg-figure" viewBox="0 0 230 245" role="img" aria-label="Messskizze: A ist die einfache Brustbreite, B die Länge des flach liegenden Kleidungsstücks."><path d="M77 32L53 42 18 82 44 105 65 83V210Q115 215 165 210V83L186 105 212 82 177 42 153 32Q143 48 115 48T77 32Z" fill="#f0ede3" stroke="#687b68" stroke-width="2" stroke-linejoin="round"/><path d="M77 32Q115 61 153 32M65 201Q115 205 165 201" fill="none" stroke="#b8c4b3" stroke-width="2"/><path d="M68 100H162M73 96L68 100 73 104M157 96L162 100 157 104M181 33V211M177 38L181 33 185 38M177 206L181 211 185 206" fill="none" stroke="#214f3a" stroke-width="2"/><path d="M155 33H188M166 211H188" stroke="#a6b59d" stroke-width="1.3" stroke-dasharray="3 3"/><rect x="102" y="85" width="26" height="29" rx="13" fill="white"/><text x="115" y="106" text-anchor="middle">A</text><rect x="168" y="110" width="28" height="30" rx="14" fill="white"/><text x="182" y="132" text-anchor="middle">B</text></svg><div><p class="kg-sg-fit"></p><p class="kg-sg-instructions"><strong>Lieblingsstück flach hinlegen.</strong><br>Vergleiche seine Maße mit der Tabelle.</p><p class="kg-sg-key"><strong>A</strong><span data-kg-width-label></span></p><p class="kg-sg-key"><strong>B</strong><span data-kg-length-label></span></p><p class="kg-sg-small">Kleidungsmaße, keine Körpermaße. Die Brustbreite ist nicht der Umfang.</p><p class="kg-sg-small" data-kg-length-instructions></p></div></div><div><table class="kg-sg-table"><thead><tr><th scope="col">Größe</th><th scope="col">A · Breite<br><span>in cm</span></th><th scope="col" data-kg-length-heading></th></tr></thead><tbody></tbody></table><p class="kg-sg-small" data-kg-tolerance></p><p class="kg-sg-small" data-kg-availability></p><p class="kg-sg-notice" hidden></p></div></div><div class="kg-sg-footer"><p class="kg-sg-summary" aria-live="polite"><strong></strong><span></span></p><button type="button" class="kg-sg-apply">Größe übernehmen</button></div><p class="kg-sg-status" role="status" aria-live="polite"></p>';
    document.body.appendChild(dialog);
    instance.dialog = dialog;
    dialog.querySelector('.kg-sg-close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('kg-size-guide-open');
      if (opened === instance) opened = null;
      var context = currentContext(instance, instance.context || {kind: 'readonly', element: instance.mount, product: instance.cfg.product});
      var opener = instance.opener && instance.opener.isConnected ? instance.opener : context && context.button;
      if (opener && visible(opener)) opener.focus({preventScroll: true});
    });
    dialog.querySelector('.kg-sg-apply').addEventListener('click', function () { apply(instance); });
    return dialog;
  }
  function show(instance, context) {
    if (opened && opened !== instance) opened.dialog.close();
    instance.context = currentContext(instance, context) || context;
    instance.opener = context.button;
    instance.pending = selection(instance.context)[sizeIndex(context.product)] || '';
    var dialog = instance.dialog || buildDialog(instance);
    dialog.querySelector('.kg-sg-status').textContent = '';
    render(instance);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('kg-size-guide-open');
    opened = instance;
    dialog.querySelector('.kg-sg-close').focus({preventScroll: true});
  }
  function render(instance) {
    var context = currentContext(instance, instance.context);
    if (!context) { instance.dialog.querySelector('.kg-sg-status').textContent = 'Die Auswahl wurde aktualisiert. Bitte öffne die Größentabelle erneut.'; instance.dialog.querySelector('.kg-sg-apply').disabled = true; return; }
    instance.context = context;
    var product = context.product;
    var chart = instance.cfg.charts[product.model];
    var dialog = instance.dialog;
    var index = sizeIndex(product);
    var rows = chart.rows.filter(function (row) { return product.variants.some(function (variant) { return equalSize(row, variant.options[index]); }); });
    var hasPrevious = rows.some(function (row) { return row.lengthPrevious != null; });
    var itemTitle = context.kind === 'smart' && context.element.closest('.sw-kit-item') && context.element.closest('.sw-kit-item').querySelector('.sw-slot-title');
    dialog.querySelector('.kg-sg-subtitle').textContent = (itemTitle ? itemTitle.textContent.trim() : product.title) + ' · ' + chart.label + ' · Maße in cm';
    dialog.querySelector('.kg-sg-fit').textContent = chart.fit || '';
    dialog.querySelector('[data-kg-width-label]').textContent = chart.measurement && chart.measurement.widthLabel || 'Brustbreite · einfach';
    dialog.querySelector('[data-kg-length-label]').textContent = chart.measurement && chart.measurement.lengthLabel || 'Länge';
    dialog.querySelector('[data-kg-length-instructions]').textContent = chart.measurement && chart.measurement.lengthInstructions || '';
    dialog.querySelector('[data-kg-length-heading]').innerHTML = hasPrevious ? 'B · Länge<br><span>alt / neu · cm</span>' : 'B · Länge<br><span>in cm</span>';
    var tbody = dialog.querySelector('tbody');
    var fragment = document.createDocumentFragment();
    rows.forEach(function (row) {
      var tr = node('tr');
      var selected = equalSize(row, instance.pending);
      tr.dataset.selected = String(selected);
      var td = node('td');
      if (context.kind === 'readonly') td.textContent = row.size;
      else {
        var button = node('button', 'kg-sg-row-size', row.size);
        button.type = 'button';
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = !targetFor(context, row);
        button.setAttribute('aria-label', 'Größe ' + row.size + (button.disabled ? ' in dieser Farbe nicht verfügbar' : ' auswählen'));
        button.addEventListener('click', function () { instance.pending = row.size; render(instance); var match = Array.from(dialog.querySelectorAll('.kg-sg-row-size')).find(function (b) { return b.textContent === row.size; }); if (match) match.focus({preventScroll: true}); });
        td.appendChild(button);
      }
      tr.appendChild(td);
      tr.appendChild(node('td', '', format.format(row.width)));
      tr.appendChild(node('td', '', (row.lengthPrevious != null ? format.format(row.lengthPrevious) + ' / ' : '') + format.format(row.length)));
      fragment.appendChild(tr);
    });
    tbody.replaceChildren(fragment);
    dialog.querySelector('[data-kg-tolerance]').textContent = chart.toleranceCm != null ? 'Herstellermaße. Messtoleranz ±' + format.format(chart.toleranceCm) + ' cm.' : 'Herstellermaße. Fertigungsbedingte Abweichungen sind möglich.';
    dialog.querySelector('[data-kg-availability]').textContent = context.kind === 'readonly' ? 'Verfügbare Größen können je nach Farbe abweichen.' : 'Ausgegraute Größen sind in deiner gewählten Farbe nicht verfügbar.';
    var notice = dialog.querySelector('.kg-sg-notice');
    notice.textContent = chart.notice || '';
    notice.hidden = !chart.notice;
    var row = rowFor(chart, instance.pending);
    dialog.querySelector('.kg-sg-summary strong').textContent = row ? 'Deine Auswahl: ' + row.size : 'Welche Größe passt dir?';
    dialog.querySelector('.kg-sg-summary span').textContent = row ? format.format(row.width) + ' cm breit · ' + (row.lengthPrevious != null ? format.format(row.lengthPrevious) + ' / ' : '') + format.format(row.length) + ' cm lang' : 'Vergleiche ein gut sitzendes Kleidungsstück.';
    var applyButton = dialog.querySelector('.kg-sg-apply');
    applyButton.hidden = context.kind === 'readonly';
    applyButton.textContent = row ? 'Größe ' + row.size + ' übernehmen' : 'Größe auswählen';
    applyButton.disabled = !row || !targetFor(context, row);
  }
  function apply(instance) {
    var context = currentContext(instance, instance.context);
    var chart = context && instance.cfg.charts[context.product.model];
    var row = chart && rowFor(chart, instance.pending);
    var target = row && targetFor(context, row);
    if (!target) {
      render(instance);
      instance.dialog.querySelector('.kg-sg-status').textContent = 'Diese Größe ist für deine aktuelle Farbauswahl nicht verfügbar. Bitte wähle eine andere Größe.';
      return;
    }
    // Use the exact existing control and preserve every non-size option.
    if (target.control.tagName === 'SELECT') {
      target.control.value = target.value;
      target.control.dispatchEvent(new Event('change', {bubbles: true}));
    } else {
      var wasChecked = target.control.checked;
      target.control.click();
      if (wasChecked) target.control.dispatchEvent(new Event('change', {bubbles: true}));
    }
    instance.dialog.close();
  }
  function scan() {
    instances.forEach(function (instance, mount) {
      if (mount.isConnected) return;
      if (instance.dialog) { if (instance.dialog.open) instance.dialog.close(); instance.dialog.remove(); }
      instance.bindings.forEach(function (binding) { binding.wrap.remove(); });
      instances.delete(mount);
    });
    document.querySelectorAll('[data-kg-size-guide]').forEach(function (mount) {
      var instance = instances.get(mount);
      if (!instance) {
        var cfg = configFor(mount);
        if (!cfg) return;
        instance = bootstrap(mount, cfg);
        if (!instance) return;
        instances.set(mount, instance);
      }
      attach(instance);
    });
  }
  function init() {
    scan();
    var main = document.getElementById('MainContent') || document.body;
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        if (owned(record.target)) return false;
        if (record.type === 'attributes') return true;
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (n) { return n.nodeType === 1 && !owned(n); });
      })) schedule();
    }).observe(main, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']});
    document.addEventListener('change', function (event) {
      if (owned(event.target)) return;
      schedule();
      if (opened && opened.context) {
        requestAnimationFrame(function () { if (opened) { opened.pending = selection(currentContext(opened, opened.context))[sizeIndex(opened.context.product)] || ''; render(opened); } });
      }
    }, true);
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      var url;
      try { url = new URL(anchor.href, location.href); } catch (error) { return; }
      if (url.origin !== location.origin) return;
      instances.forEach(function (instance) {
        if (event.defaultPrevented || !instance.scope.contains(anchor)) return;
        var chart = instance.cfg.charts[instance.cfg.product.model];
        if (!chart.page || !chart.page.url) return;
        var page = new URL(chart.page.url, location.href);
        if (url.pathname.replace(/\/$/, '') !== page.pathname.replace(/\/$/, '')) return;
        attach(instance);
        var binding = instance.bindings.find(function (b) { return id(b.product.id) === id(instance.cfg.product.id) && visible(b.element) && b.kind !== 'readonly'; }) || instance.bindings.find(function (b) { return b.kind === 'readonly'; });
        if (!binding) return;
        event.preventDefault();
        show(instance, binding);
      });
    });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
